import { useQuery } from "@tanstack/react-query";
import type {
	TestShackReport,
	TestShackReportRequest,
} from "../../models/TestShackReport";
import { getTestShackReport } from "../../repositories/TestShackReportRepository";

interface UseTestShackReportQueryProps extends TestShackReportRequest {
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useTestShackReportQuery = ({
	enabled = true,
	onError,
	...request
}: UseTestShackReportQueryProps) =>
	useQuery<TestShackReport, Error>({
		queryKey: [
			"test-shack-report",
			request.assetId,
			request.startDate?.getTime() ?? null,
			request.endDate?.getTime() ?? null,
			request.shiftId,
			request.sectionId,
			request.eventId,
			request.heatId,
			request.problemsOnly,
		],
		meta: { realtime: ["DIM.GetProfileInspectionReport"] },
		queryFn: ({ signal }) => getTestShackReport(request, signal),
		enabled,
		onError,
	});
